import React, { createContext, useState } from 'react';

export const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);
  const [dialogStyles, setDialogStyles] = useState({});

  const openDialog = (dialogComponent, customStyles = {}) => {
    setDialog(dialogComponent);
    setDialogStyles(customStyles);
  };

  const closeDialog = () => {
    setDialog(null);
    setDialogStyles({});
  };

  return (
    <DialogContext.Provider value={{ dialog, dialogStyles, openDialog, closeDialog }}>
      {children}
    </DialogContext.Provider>
  );
};